<div class="calculated-field" data-testid="calculated-field-display">
  @if (props['label']) {
  <label class="calculated-label" [for]="id">{{ props['label'] }}</label>
  }

  @if (formattedValue !== null) {
  <div class="calculated-value" [attr.id]="id">{{ formattedValue }}</div>
  } @else {
  <div class="calculated-value calculated-empty" [attr.id]="id">
    {{ 'formBuilder.calculated.runtimeEmpty' | translate }}
  </div>
  }
</div>